import React from 'react';
import SmartLink from '../SmartLink/SmartLink';
import './TopCategoryStory.css';

const SHAPES = ['leaf', 'petal', 'circle', 'arch', 'rounded', 'square', 'card'];
const SIZES = ['small', 'medium', 'large'];
const RINGS = ['none', 'solid', 'gradient'];
const pick = (value, options, fallback) => (options.includes(value) ? value : fallback);

// Category pictures at the top of the home page — Admin → Customize → Category Circles.
// Shape, size, ring and colours are chosen there. In automatic mode the server fills
// `items` from the store's active categories.
const TopCategoryStory = ({ content }) => {
  const items = content?.items || [];
  if (!content || items.length === 0) return null;

  const shape = pick(content.shape, SHAPES, 'leaf');
  const size = pick(content.size, SIZES, 'medium');
  const ring = pick(content.ring, RINGS, 'none');
  const style = {
    '--cs-ring': content.ringColor || 'var(--color-primary)',
    '--cs-label': content.labelColor || '#2D2226',
    '--cs-bg': content.background || '#FFFFFF'
  };

  return (
    <section
      className={`top-category-story-wrapper cs-shape-${shape} cs-size-${size} cs-ring-${ring} cs-align-${content.align === 'left' ? 'left' : 'center'}`}
      style={style}
      aria-label="Shop by category"
    >
      <div className="leaf-categories-scroller-container">
        <div className="leaf-categories-scroller">
          {items.map((cat) => (
            <SmartLink key={cat.id} to={cat.link} className="leaf-category-item" title={`Shop ${cat.label}`}>
              <div className="cs-frame">
                <div className="leaf-shape-outer">
                  <div className="leaf-pastel-backdrop"></div>
                  {cat.image && <img src={cat.image} alt={cat.label} className="leaf-category-img" loading="lazy" />}
                  {shape === 'card' && <span className="cs-card-label">{cat.label}</span>}
                </div>
              </div>
              {shape !== 'card' && <span className="leaf-category-label">{cat.label}</span>}
            </SmartLink>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopCategoryStory;
